module.exports = __webpack_public_path__ + "static/media/chevron_blue.15b383e7.svg";